module.exports = __webpack_public_path__ + "img/partener-6.2bce9139.png";